import { AxiosStatic } from "axios";

import { ISettings } from ".";
import Settings from "./data/settings";
export * from "./i18n";

export interface UderlyInitConfig {
    externalSettings?: ISettings;
    Axios?: AxiosStatic;
    disableSyncSettings?: boolean;
}

export const uderlyConfig: UderlyInitConfig = {}

export const uderlyInitConfig = (config?: UderlyInitConfig) => {
    if (config) {
        Object.assign(uderlyConfig, config);

        if (config.externalSettings) {
            const mergedSettings = Object.assign(Settings, config.externalSettings);

            if (!config.disableSyncSettings)
                Object.assign(config.externalSettings, mergedSettings);

            mergedSettings.enableLog && console.log("External settings merged with default internal ones.", mergedSettings);
        }
    }

    return Settings;
}